var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPinFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5155_90533)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5155_90533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5155_90533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10823 13.7675C4.08238 12.7417 2.48137 11.1406 2.48137 11.1406C1.69333 10.3531 2.00205 9.01227 3.05498 8.64866C3.05498 8.64866 4.30639 11.7685 5.10823 13.7675ZM5.10823 13.7675C3.44856 15.4274 0.858374 18.0179 0.858374 18.0179L0.799805 18.0765V18.1593V18.9998V19.1998H0.999805H1.84076H1.9236L1.98218 19.1412L6.23202 14.8913L8.85892 17.5182C9.64684 18.3062 10.9871 17.9976 11.3508 16.9446L12.6279 13.2487C12.6616 13.1512 12.732 13.0707 12.8242 13.0245C12.8242 13.0245 8.12151 13.4774 5.10823 13.7675ZM6.75079 7.37199L3.05498 8.64866L12.8242 13.0245L17.84 10.5168C19.3414 9.76608 19.6661 7.76492 18.4789 6.57815L13.4217 1.52039C12.2345 0.333688 10.2334 0.658248 9.48262 2.15981L6.97496 7.17523C6.92885 7.26756 6.84832 7.33827 6.75079 7.37199Z",
    fill: "#1ABB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05498 8.64866C3.05498 8.64866 4.30639 11.7685 5.10823 13.7675C8.12151 13.4774 12.8242 13.0245 12.8242 13.0245L3.05498 8.64866Z",
    fill: "#1ABB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10823 13.7675C4.08238 12.7417 2.48137 11.1406 2.48137 11.1406C1.69333 10.3531 2.00205 9.01227 3.05498 8.64866M5.10823 13.7675C4.30639 11.7685 3.05498 8.64866 3.05498 8.64866M5.10823 13.7675C3.44856 15.4274 0.858374 18.0179 0.858374 18.0179L0.799805 18.0765V18.1593V18.9998V19.1998H0.999805H1.84076H1.9236L1.98218 19.1412L6.23202 14.8913L8.85892 17.5182C9.64684 18.3062 10.9871 17.9976 11.3508 16.9446L12.6279 13.2487C12.6616 13.1512 12.732 13.0707 12.8242 13.0245M5.10823 13.7675C8.12151 13.4774 12.8242 13.0245 12.8242 13.0245M3.05498 8.64866L6.75079 7.37199C6.84832 7.33827 6.92885 7.26756 6.97496 7.17523L9.48262 2.15981C10.2334 0.658248 12.2345 0.333688 13.4217 1.52039L18.4789 6.57815C19.6661 7.76492 19.3414 9.76608 17.84 10.5168M3.05498 8.64866L12.8242 13.0245M12.8242 13.0245L17.84 10.5168M17.84 10.5168L17.7505 10.3379",
    stroke: "#1ABB78",
    strokeWidth: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5155_90533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinFill);
export default __webpack_public_path__ + "static/media/ic_pin_fill.efae6f2b99ea2ef35f0d0318ba4d14eb.svg";
export { ForwardRef as ReactComponent };